import type { IBusTimetableDemandInterval } from 'types/models/i-bus-timetable-demand-interval'
import type { IBusTimetableFrequencyInterval } from 'types/models/i-bus-timetable-frequency-interval'
import { defineAsyncComponent } from 'vue'

const BusTimetable = defineAsyncComponent(() => import('./bus-timetable.vue'))

const BusTimetableFormModal = defineAsyncComponent(() => import('./bus-timetable-form-modal.vue'))

const BusTimetablesTable = defineAsyncComponent(() => import('./bus-timetables-table.vue'))

const DefaultMinutesEvery = 15
const DefaultPax = 15

enum SelectTabBusTimetable {
  FREQUENCY_SHUTTLES = 'Frequency-based shuttles',
  DEMAND_SHUTTLES = 'Demand-based shuttles',
}

const DefaultFrequencyInterval: WithVueComponentId<IBusTimetableFrequencyInterval> = {
  vueIdComponent: 0,
  startAt: null,
  endAt: null,
  minutesEvery: DefaultMinutesEvery,
  isEmptyRunsInterval: false,
  busTimetableTrips: null,
}

const DefaultDemandInterval: WithVueComponentId<IBusTimetableDemandInterval> = {
  vueIdComponent: 0,
  startAt: null,
  endAt: null,
  pax: DefaultPax,
  isEmptyRunsInterval: false,
  busTimetableTrips: null,
}

export {
  BusTimetable,
  BusTimetableFormModal,
  BusTimetablesTable,
  DefaultDemandInterval,
  DefaultFrequencyInterval,
  DefaultMinutesEvery,
  DefaultPax,
  SelectTabBusTimetable,
}
